module.exports = __webpack_public_path__ + "img/xss_comments-2221.5edee2e6.jpeg";